import React, { useState, useEffect } from 'react'
import {
    Card,
    CardBody,
    Table,
    Col,
    CardTitle,
    Input,
    Button,
    CardHeader,
    Label
} from "reactstrap";

import HistoryService from "../services/history.service"
import moment from 'moment'

function Orders() {
    const [histories, setHistories] = useState([])
    const [dataProps, setDataProps] = useState([])

    useEffect(() => {
        HistoryService.getHistory().then((result) => {
            setHistories(result.data)
        })
    }, [])

    function table() {
        return (
            <Table className="table-hover reponsive" style={{ marginTop: "10px", lineHeight: "15px" }}>
                <thead className="text-primary">
                    <tr>
                        <th className="table-device-mobile">Người thực hiện</th>
                        <th >Phần mềm</th>
                        <th className="table-device-mobile" >Hành động</th>
                        <th  >Thông báo</th>
                        <th className="table-device-mobile">Thời gian</th>
                    </tr>
                </thead>
                <tbody>
                    {loadFillData()}
                </tbody>
            </Table>
        )
    }

    function loadFillData() {
        return histories.map((data, key) => {
            if (data.action == "Thêm") data.color = "table-success"
            if (data.action == "Gia hạn") data.color = "table-info"
            if (data.action == "Sửa") data.color = "table-warning"
            if (data.action == "Xóa") data.color = "table-danger"

            return (
                <tr className={data.color} style={{ cursor: "pointer" }} key={key}>
                    <th className="table-device-mobile">{data.user}</th>
                    <td >{data.tool}</td>
                    <td className="table-device-mobile">{data.action}</td>
                    <td >{data.message}</td>
                    <td className="table-device-mobile">{moment(data.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                </tr>
            )
        })
    };

    return (
        <div className="content">
            <div className="card" style={{ padding: '15px', borderRadius: '30px' }}>
                <CardHeader>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                        <Label
                            style={{
                                fontSize: '24px',
                                color: 'DimGray',
                                fontWeight: 'bold',
                                margin: 0,
                                width: "100%",
                                textAlign: "center",
                                marginBottom: "15px"
                            }}
                            className="d-block d-md-none"
                        >
                            Lịch sử thao tác
                        </Label>
                        <Label
                            style={{
                                fontSize: '24px',
                                color: 'DimGray',
                                fontWeight: 'bold',
                                margin: 0
                            }}
                            className="d-none d-md-block"
                        >
                            Lịch sử thao tác
                        </Label>
                    </div>
                </CardHeader>

                <CardBody className="px-md-3 px-0 py-3">
                    {table()}
                </CardBody>
            </div>

        </div>
    )
}

export default Orders